<template>
  <div>
    <v-card :xl-only="true">
      <v-card-title>
        <h3>部屋情報の追加入力</h3>
      </v-card-title>
      <room-table
        :items="form.rooms"
        :floor="form.floors"
        :error-messages="error"
        :readonly="form.readonly"
        :removable="!form.readonly"
        :is-field="true"
        :previous-object="previousObject"
        :created="!!form.field_survey_created_at"
        :applied="!!form.field_survey_apply_status"
        @insert="onRoomInserted"
        @update="onRoomUpdated"
        @remove="onRoomRemoved"
        @replace="onRoomReplaced"
        @disable="onRoomDisabled"
        @updateFirst="onCopyRenovationYear1"
        @updateSecond="onCopyRenovationYear2"
        @enable="onRoomEnable">
      </room-table>
      <global-footer>
        <template #left>
          <v-btn
            large
            @click.prevent="onReturnClicked">
            <v-icon>mdi-chevron-left</v-icon>
            戻る
          </v-btn>
        </template>
        <template #right>
          <v-btn
            v-if="!form.readonly"
            large
            color="default"
            class="mr-1"
            :disabled="!hasChanges"
            @click.prevent="onDraftSaveClicked">
            ブラウザに一時保存
          </v-btn>
          <v-btn
            large
            color="primary"
            @click.prevent="onNextClicked">
            次へ
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
      </global-footer>
    </v-card>
  </div>
</template>

<script>
import RoomTable from '../RoomTable'
import RoomControl from '../../mixins/RoomControl'
import {
  getStepSession,
  markAsUnsavedSession,
  setStepObjectId,
  setStepSession,
} from '../../logic/session'
import PreviousDiff from '../../mixins/PreviousDiff'

export default {
  name: 'FieldFormStep2',
  components: {
    RoomTable,
  },
  mixins: [RoomControl],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    previousObject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        rooms: [],
      },
      error: {},
      hasChanges: false,
    }
  },
  watch: {
    hasChanges() {
      this.$emit('hasChange', this.hasChanges)
    },
  },
  mounted() {
    this.loadItem()
  },
  methods: {
    loadItem() {
      const form = getStepSession('field-survey', 1)
      if (form) {
        this.form = form
      }
      // 変更があればフラグをセット
      this.$watch('form', () => {
        this.hasChanges = true
      }, { deep: true })
    },
    async validateItem() {
      try {
        const { rooms } = this.form
        const hasRoomChanges = rooms.filter(room => !room.id).length > 0
        if (hasRoomChanges) {
          const { data } = await window.axios.put(`/api/field-surveys/rooms/${this.id}`, { rooms })
          this.form.rooms = data
          setStepSession('field-survey', 1, this.form)
        } else {
          await window.axios.post('/api/field-surveys/step2', this.form)
        }
        this.error = {}
        return true
      } catch (e) {
        if (e.response.status === 422) {
          this.error = e.response.data.errors
        }
      }
      return false
    },
    onReturnClicked() {
      this.$emit('change', 1)
    },
    async onNextClicked() {
      if (this.form.readonly) {
        this.$emit('change', 3)
        return
      }
      if (await this.validateItem()) {
        if (this.hasChanges) {
          markAsUnsavedSession('field-survey')
        }
        setStepSession('field-survey', 1, this.form)
        setStepSession('field-survey', 3, this.form.id)
        setStepObjectId('field-survey', this.form.id)
        this.$emit('change', 3)
      }
    },
    onDraftSaveClicked() {
      setStepSession('field-survey', 1, this.form)
      markAsUnsavedSession('field-survey')
      this.hasChanges = false
    },
    onRoomInserted(index) {
      // 現地調査での部屋追加は部屋番号を枝番で採番し、以降の部屋番号をずらさないようにする。
      this.copyNewRoom(index)
      this.reIndexRoomNumber(index + 1)
      let num = 1
      while (num < 100) {
        const names = this.form.rooms[index].room_no.split('-')
        const roomNo = `${names[0]}-${names[1]}-${num}`
        if (this.form.rooms.filter(room => room.room_no === roomNo).length <= 0) {
          this.$set(this.form.rooms[index + 1], 'room_no', roomNo)
          break
        }
        num += 1
      }
    },
    hasDiff(previous, current) {
      return this.form.field_survey_created_at && !!this.project.field_survey_apply_status
        ? this.$super(PreviousDiff).hasDiff(previous, current)
        : false
    },
  },
}
</script>

<style scoped>
.delete-part {
  width: 20px;
  height: 20px;
}
</style>
